import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import * as apiService from '@doctoroncallcom/api';
import * as session from '../../utils/session';
import useApiCall from '../../hooks/useApiCall';
import Loader from '../../components/Loader/Loader';
import { redirect } from '../../utils/redirect';

const Auth = ({ children }) => {
  const [params, setParams] = useState(null);
  const { loading, data, error, success } = useApiCall(
    params,
    apiService.user.me
  );

  useEffect(() => {
    if (!(window.location.pathname === '/logout')) {
      const user = session.getSession();
      if (user && user.token) {
        setParams({});
      }
    }
  }, []);

  useEffect(() => {
    if (success) {
      const auth = { ...session.getSession(), user: data.data };
      session.storeSession(auth);
      redirect();
    }
  }, [success]);

  useEffect(() => {
    if (error) {
      /* eslint-disable no-console */
      error && console.error(error);
    }
  }, [error]);

  // if (error) {
  //   /* eslint-disable no-console */
  //   error && console.error(error);
  // }

  // if (success === true) {
  //   redirect();
  // }
  if (loading) return <Loader height={50} width={50} hasOverlay={true} />;

  return !success ? children : null;
};

Auth.propTypes = {
  children: PropTypes.element.isRequired,
};

export default Auth;
